import { _ } from '@yishitec/web';

export default (item, fieldName) => {
  let [numOnline, numCount] = String(_.get(item, fieldName) || '').split(' / ');
  numOnline = Number(numOnline || 0);
  numCount = Number(numCount || 0);
  return [numOnline, numCount];
};
